<div class="loading-container">
    <mat-spinner></mat-spinner>
</div>